import React from "react";

interface ServiceCardProps {
  link: string;
  title: string;
  desc: string;
  img: string;
  isActive?: boolean;
  onClick?: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  link,
  title,
  desc,
  img,
  isActive = false,
  onClick,
}) => {
  return (
    <div
      className={`services_card_wrap ${isActive ? "active" : "not_active"}`}
      onClick={onClick}
    >
      <div className="services_card">
        <div className="services_card_inner">
          <h2 className="title_text">
            <a href={link}>{title}</a>
          </h2>
          <p className="description_text">{desc}</p>
        </div>
        <div className="services_card_bg">
          <img src={img} alt={title} />
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;

